import { render, staticRenderFns } from "./funnel_review.vue?vue&type=template&id=0ef66e3c&"
import script from "./funnel_review.vue?vue&type=script&lang=js&"
export * from "./funnel_review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports